export const parseStringOrArray = (value) => {
    if (typeof value === 'string')
        return value.split(',');
    if (Array.isArray(value))
        return value;
    return [];
};
